import type { FilterOperatorValue } from '@/components/InstantSearch';

// TanStack Form interprets dots in field names as nested object paths.
// Column keys can contain dots (e.g. "sector.id"), so we encode them to
// flat field names and decode back when extracting filter values.
export const encodeFilterFieldName = (key: string | number) => `${key}`.replaceAll('.', '__');

export const decodeFilterFieldName = (name: string) => name.replaceAll('__', '.');

export const cleanFilter = (
  filter: FilterOperatorValue | null | undefined,
): FilterOperatorValue | undefined => {
  if (filter == null) return undefined;
  if ('operand' in filter) {
    const operand = filter.operand.filter((s) => String(s).trim().length > 0);
    return operand.length === 0 ? undefined : { ...filter, operand };
  }
  return filter;
};
